import React from "react";
import { Card } from "react-bootstrap";
import { FiShield } from "react-icons/fi";

export default function MFAUsersCard() {
  return (
    <>
      <style>{`
        .mfa-card {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
          background: #fff;
        }

        .mfa-title {
          font-size: 15px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 8px;
          color: #0f172a;
        }

        .mfa-title svg {
          color: #f97316; /* 🔥 orange icon */
        }

        .mfa-sub {
          font-size: 13px;
          color: #64748b;
          margin: 0;
        }

        .mfa-percent {
          font-size: 16px;
          font-weight: 700;
          color: #0f172a;
        }

        /* 🔥 BAR STYLE EXACT */
        .mfa-bars {
          display: flex;
          gap: 6px;
          margin-top: 14px;
        }

        .mfa-bars span {
          flex: 1;
          height: 12px;
          border-radius: 20px;
          background: #e5e7eb;
        }

        .mfa-bars .active {
          background: #f97316;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .mfa-title {
            font-size: 15px;
          }

          .mfa-percent {
            font-size: 14px;
          }

          .mfa-bars {
            gap: 5px;
          }

          .mfa-bars span {
            height: 12px;
          }
        }
      `}</style>

      <Card className="mfa-card ">
        <Card.Body>
          {/* HEADER */}
          <div className="mfa-title mb-3 d-flex">
            <FiShield size={16} />
<strong style={{fontWeight:"650",fontSize:"17"}} >    MFA Enabled Users</strong>
        
          </div>
          {/* TEXT ROW */}
          <div className="d-flex justify-content-between align-items-center">
            <p className="mfa-sub">
              2,168 out of 2,436 users
            </p>
            <div className="mfa-percent">89%</div>
          </div>

          {/* PROGRESS BARS */}
          <div className="mfa-bars">
            {[...Array(14)].map((_, i) => (
              <span key={i} className={i < 11 ? "active" : ""}></span>
            ))}
          </div>
        </Card.Body>
      </Card>
    </>
  );
}